import { css } from "@emotion/react";
import styled from "@emotion/styled";

import type { ResponsiveVariants } from "~/lib/styles/responsive";
import { setResponsiveVariantStyles } from "~/lib/styles/responsive";

export type StyledProps = {
  $variant:
    | {
        $aspectRatio: number;
        $type: "aspectRatio";
      }
    | {
        $responsiveBlockSize: ResponsiveVariants<string>;
        $type: "responsive";
      }
    | {
        $blockSize: string;
        $type: "static";
      }
    | {
        $type: "video";
      };
};

export const Container = styled.div`
  display: grid;
`;

export const StyledIframe = styled.iframe<StyledProps>`
  ${props => {
    const variant = props.$variant;

    switch (variant.$type) {
      case "aspectRatio":
        return css`
          inline-size: 100%;
          block-size: auto;
          aspect-ratio: ${variant.$aspectRatio};

          /* set style for portrait */
          ${variant.$aspectRatio < 1 &&
          css`
            place-self: center;

            max-inline-size: 476px;
          `}
        `;
      case "responsive":
        return css`
          inline-size: 100%;
          ${setResponsiveVariantStyles(
            variant.$responsiveBlockSize,
            blockSize => css`
              block-size: ${blockSize}px;
            `,
          )}
        `;
      case "video":
        return css`
          inline-size: 100%;
          block-size: auto;
          aspect-ratio: 16 / 9;
        `;
      case "static":
        return css`
          inline-size: 100%;
          block-size: ${variant.$blockSize};
        `;
    }
  }}
`;
